/* ================================================== */
/* CHECK STICKY HEIGHT
/* ================================================== */

var $sticky = $('.sticky');

function checkStickyHeight() {
	if ($sticky.length) {
		$sticky.each(function(index, element){
			if (!$(element).is('.sticky--no-check')) {
				if ($(element).innerHeight() + 60 > $(window).height()) {
					$(element).removeClass('sticky');
				} else {
					$(element).addClass('sticky');
				}
			}
		});
	}
}

$(window).on('resize orientationchange', function(){
	checkStickyHeight();
});